import _slicedToArray from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';
import { navigationMap } from './data.js';
function capitalize(word) {
  var lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
}
function getFirstTwoNames(fullName) {
  if (!fullName) return "";
  var splittedName = fullName.split(" ");
  var firstTwoNames = splittedName.slice(0, 2);
  return firstTwoNames.join(" ");
}
function useHeaderCP(_ref) {
  var mapLoggedInMenuItems = _ref.mapLoggedInMenuItems,
    mapLoggedOutMenuItems = _ref.mapLoggedOutMenuItems,
    customLoggedInMenuItems = _ref.customLoggedInMenuItems,
    username = _ref.username;
  var _a, _b, _c;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobileMenuOpen = _useState2[0],
    setIsMobileMenuOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmenuOpen = _useState4[0],
    setIsMobileSubmenuOpen = _useState4[1];
  var capitalizedUsername = capitalize(username);
  var firstTwoNames = getFirstTwoNames(capitalizedUsername);
  function toggleMobileMenu() {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  }
  function openSubmenu(e) {
    var browserWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (browserWidth > 720) return;
    e.preventDefault();
    setIsMobileSubmenuOpen(true);
  }
  function closeSubmenu() {
    setIsMobileSubmenuOpen(false);
  }
  var publicLinks = mapLoggedOutMenuItems ? mapLoggedOutMenuItems((_a = navigationMap) == null ? void 0 : _a.publicLinks) : (_b = navigationMap) == null ? void 0 : _b.publicLinks;
  var loggedInMenu = customLoggedInMenuItems || ((_c = navigationMap) == null ? void 0 : _c.privateLinks);
  var privateLinks = mapLoggedInMenuItems ? mapLoggedInMenuItems(loggedInMenu) : loggedInMenu;
  return {
    unloggedMenuItems: [],
    isMobileMenuOpen: isMobileMenuOpen,
    toggleMobileMenu: toggleMobileMenu,
    openSubmenu: openSubmenu,
    closeSubmenu: closeSubmenu,
    isSubmenuOpen: isSubmenuOpen,
    formattedUsername: firstTwoNames,
    loggedoutNavigationLinks: publicLinks,
    loggedNavigationLinks: privateLinks
  };
}
export { useHeaderCP as default };